import ColorEditor from './ColorEditor';
import './ColorEditor.scss';
export default ColorEditor;
